import { useContext, useEffect, useRef } from 'react';

import { CartContext } from '@bytel/leviator/react';

import type { PageViewTrackingType } from '@app-types/tracking';

import { sendPageViewTracking } from '@helpers/tracking';

type PageViewTrackingConfig = {
    enable?: boolean;
    key?: string;
};

export function usePageViewTracking(data: PageViewTrackingType, config: PageViewTrackingConfig = {}) {
    const { enable = true, key } = config;
    const { cart } = useContext(CartContext);
    const hasFiredRef = useRef(false);
    const resetKey = key ?? data.page;
    const lastResetKeyRef = useRef(resetKey);

    if (lastResetKeyRef.current !== resetKey) {
        lastResetKeyRef.current = resetKey;
        hasFiredRef.current = false;
    }

    // biome-ignore lint/correctness/useExhaustiveDependencies: we only want to trigger this effect when the page/key changes or enable becomes true
    useEffect(() => {
        if (enable && !hasFiredRef.current) {
            hasFiredRef.current = true;
            sendPageViewTracking(cart, data);
        }
    }, [resetKey, enable]);
}
